module.exports = __webpack_public_path__ + "static/media/banner_evo-half.515e7651.webp";